export default __webpack_public_path__ + "static/media/vqa_noimg_jp.f32192b4.jpg";